import React from "react";

import { Radio as AntRadio, RadioGroupProps as Props, Space } from "antd";
import { CheckboxOptionType } from "antd/lib";

import { Spin, Typography } from "components";

export type KlimRadioGroupOptionType = CheckboxOptionType & {
  additionalInfo?: {
    loading: boolean;
    text: string;
  };
};

export type KlimRadioGroupProps = Omit<Props, "options"> & {
  dataTestId?: string;
  fullWidth?: boolean;
  options: KlimRadioGroupOptionType[];
  required?: boolean;
  type?: "primary" | "secondary" | "tertiary" | "other";
  vertical?: boolean;
  disabled?: boolean;
};

export const KlimRadioGroup = ({ fullWidth, options, required = false, vertical = false, disabled, dataTestId, ...props }: KlimRadioGroupProps) => {
  const optionElements = options?.map((option) => (
    <AntRadio
      className={`radio ${options?.some((option) => option.additionalInfo?.text) && "additional-info"}`}
      data-testid={dataTestId ? `${dataTestId}-${option.value}` : undefined}
      key={option.value.toString()}
      required={required}
      value={option.value}
    >
      <div className="radio-content">
        <Typography variant="paragraph-m" className="label">
          {option.label}
        </Typography>
        {option.additionalInfo?.loading ? (
          <Spin size="small" />
        ) : (
          option.additionalInfo?.text && (
            <Typography variant="paragraph-m" className="info-text">
              {option.additionalInfo?.text}
            </Typography>
          )
        )}
      </div>
    </AntRadio>
  ));

  return (
    <AntRadio.Group
      {...props}
      className={`radio-group ${props.type ?? "primary"} ${props.size ?? "middle"} ${options?.some((option) => option.additionalInfo) && "additional-info"} ${
        fullWidth && "full-width"
      }  ${props.className}`}
      data-testid={dataTestId}
      disabled={disabled}
    >
      {vertical ? <Space direction="vertical">{optionElements}</Space> : optionElements}
    </AntRadio.Group>
  );
};
